import { FC, memo, useCallback, useContext, useEffect, useLayoutEffect, useReducer, useState } from "react";
import PaginationNav from "src/components/actionDashboard/paginationNav";
import NoDataFound from "src/components/noDataFoundComponent";
import { QueryParamsState } from "src/components/manufacturer/caseListing";
import { AllClaimsTypeProps } from "../actionDashboard/types";
import CopayAllClaimsHeader from "src/components/copayClaims/allClaimsTableHeader";
import AllClaimsTableRow from "src/components/copayClaims/allClaimsTableRow";
import useFetch from "src/hooks/useFetch";
import { APIEndpoints } from "src/types/apiTypes";
import { AllClaimsResponseType, ClaimQueryParamsState, ClaimQueryStateActions, ClaimQueryStateActionType, CopayAllClaimsTypeProps } from "./types";
import { claimInitialState, ClaimQueryParamReducer } from "./reducer";
import { LoaderContext } from "src/context/loaderContext";
import { AuthContext } from "src/context/authContext";
import CopayFilter from "src/components/copayFilter";
import { downloadExcelFile } from "src/helpers/downloadFile";
import { format, parse } from "date-fns";
import { ToastContext } from "src/context/toastContext";
import { ToastTypes } from "src/types";
import { useLocation } from "react-router-dom";
import { da } from "date-fns/locale";


const AllClaims: FC<CopayAllClaimsTypeProps> = ({ currentPage, initialState, refreshListing, activeTab }): JSX.Element => {

  const [sortedData, setSortedData] = useState<AllClaimsTypeProps[]>([]);
  const [maxRecordData, setMaxRecordsData] = useState<number>(0);
  const location = useLocation();
  const [queryParams, dispatch] = useReducer(
    ClaimQueryParamReducer,
    claimInitialState,
    (initialState) => ({
      ...initialState,
      days_left: location.search.includes("?isFromModal:true") ? 15 : 90,
    })
  ); 
  const { setLoader, hideLoader } = useContext(LoaderContext);
  const { showToast } = useContext(ToastContext);
  const { userData } = useContext(AuthContext);
  const [isExportingInProgress, setExportingInProgressStatus] = useState<boolean>(false);
  const [isPaginationUpdated, updatePaginationChange] = useState<boolean>(false)
  console.log("Location in All Claims Page...", location.search);
  const [Queries, setUpdatedQueries] = useState<ClaimQueryParamsState>({
    ...queryParams,
    days_left: location.search.includes("?isFromModal:true") ? 15 : 90
  });


  useLayoutEffect(() => {
    setLoader();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);



  const { data: allClaimsData, error: allClaimsError, mutate: allClaimsUpdateData } =
    useFetch<AllClaimsResponseType>(APIEndpoints.ALL_CLAIMS, Queries, {}, true)

  useEffect(() => {
    if (allClaimsData || allClaimsError) {
      hideLoader()
      if (allClaimsData) {
        sessionStorage.setItem("loginModalShown", "false");
        if (queryParams.pagination) {
          setSortedData(
            [...allClaimsData.records].sort((a, b) => a.days_left - b.days_left)
          ); setMaxRecordsData(allClaimsData.max_page)

        } else if (allClaimsData.response && allClaimsData.response.length > 0) {
          dispatch({
            type: ClaimQueryStateActions.CHANGE_PAGINATION_BIT,
            payload: true,
          })
          downloadExcelFile(allClaimsData.response, `${allClaimsData.report_name}.xlsx`);
          setExportingInProgressStatus(false)
        } else {
          setExportingInProgressStatus(false)
          dispatch({
            type: ClaimQueryStateActions.CHANGE_PAGINATION_BIT,
            payload: true,
          })
          showToast(['Report cannot be generated'], ToastTypes.ERROR);
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [allClaimsData, allClaimsError]);
  const [queryParam, setQueryParam] = useState<QueryParamsState>({
    direction: "desc",
    sort_by: "days_left",
  });
  //Case ID, Submitted, Patient, Submitting Practice, Days Left)
  const changeIdOrder = (tableHeader: string) => {
    const newParams: QueryParamsState = {
      sort_by: tableHeader,
      direction:
        tableHeader === queryParam.sort_by
          ? queryParam.direction === "desc"
            ? "asc"
            : "desc"
          : "desc",
    };

    let sorted = [...(sortedData || [])];

    switch (newParams.sort_by) {
      case "case_id":
        sorted.sort((a, b) =>
          newParams.direction === "asc"
            ? Number(a.case_id) - Number(b.case_id)
            : Number(b.case_id) - Number(a.case_id)
        );
        break;
      case "patient_name":
        sorted.sort((a, b) =>
          newParams.direction === "desc"
            ? (a.patient_name || "").localeCompare(b.patient_name || "")
            : (b.patient_name || "").localeCompare(a.patient_name || "")
        );
        break;
      case "submitted_date":
        sorted.sort((a, b) =>
          newParams.direction === "desc"
            ? (a.submitted_date || "").localeCompare(b.submitted_date || "")
            : (b.submitted_date || "").localeCompare(a.submitted_date || "")
        );
        break;
      case "submitting_practice":
        sorted.sort((a, b) =>
          newParams.direction === "desc"
            ? (a.submitting_practice || "").localeCompare(b.submitting_practice || "")
            : (b.submitting_practice || "").localeCompare(a.submitting_practice || "")
        );
        break;
      case "days_left":
        sorted.sort((a, b) =>
          newParams.direction === "desc"
            ? Number(a.days_left) - Number(b.days_left)
            : Number(b.days_left) - Number(a.days_left)
        );
        break;
      default:
        break;
    }
    setSortedData(sorted);
    setQueryParam(newParams);
  };


  const onClearButtonClicked = () => {
    setLoader()
    dispatch({
      type: ClaimQueryStateActions.CLEAR_STATE,
      payload: false
    });
    setUpdatedQueries({ ...queryParams, days_left: 90, claim_status: '', case_id: '', start_date: '', end_date: '', patient_name: '', file_required: false, page: 1 })
    allClaimsUpdateData({}, {}, { ...queryParams, days_left: 90, claim_status: '', case_id: '', start_date: '', end_date: '', patient_name: '', file_required: false, page: 1 })
  };

  //👇 jab data load ho jaye tab default tab set karo


  const onPageChanged = (pageObj: { selected: number }) => {
    const action: ClaimQueryStateActionType = {
      type: ClaimQueryStateActions.CHANGE_PAGE,
      payload: pageObj.selected + 1,
    };
    updatePaginationChange(true)
    const tempParams = {
      ...queryParams,
    };
    const newState = ClaimQueryParamReducer(tempParams, action);
    dispatch(action);
    setLoader();

    dispatch(action);
    updatePaginationChange(true)
    allClaimsUpdateData({}, {}, { ...newState })

  };


  const handlePageChange = useCallback(
    (pageObj: { selected: number }) => onPageChanged(pageObj),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [queryParams]
  );

  const updateQueryParamsAndCallAPI = (updatedState: ClaimQueryParamsState): void => {
    const queryParams = {
      ...updatedState,
      start_date: updatedState.start_date && (format(parse(updatedState.start_date, "MM/dd/yyyy", new Date()), "yyyy-MM-dd")),
      end_date: updatedState.end_date && (format(parse(updatedState.end_date, "MM/dd/yyyy", new Date()), "yyyy-MM-dd")),
      days_left: updatedState.days_left && updatedState.days_left > 0 ? updatedState.days_left : 90
    };
    dispatch({
      type: ClaimQueryStateActions.CHANGE_SORT_PARAMS,
      payload: queryParams,
    });

    dispatch({
      type: ClaimQueryStateActions.CHANGE_PAGE,
      payload: 1,
    });

    console.log({ ...updatedState }, "updatedState")

    setLoader();
    allClaimsUpdateData({}, {}, { ...queryParams, pagination: true, file_required: false, page: 1 })
  };

  const downloadExcel = () => {
    setExportingInProgressStatus(true)
    dispatch({
      type: ClaimQueryStateActions.CHANGE_PAGINATION_BIT,
      payload: false,
    })
    //setLoader();
    const params = {
      ...queryParams,
      start_date: queryParams.start_date && (format(parse(queryParams.start_date, "MM/dd/yyyy", new Date()), "yyyy-MM-dd")),
      end_date: queryParams.end_date && (format(parse(queryParams.end_date, "MM/dd/yyyy", new Date()), "yyyy-MM-dd")),
      days_left: queryParams.days_left && queryParams.days_left > 0 ? queryParams.days_left : 90

    };
    allClaimsUpdateData({}, {}, { ...params, pagination: false, file_required: true })
  }




  return (
    <>
      <div className="row my-4">
        <div className="col-12 col-lg-9 mb-2 mb-lg-0">
          <CopayFilter
            state={queryParams}
            dispatch={dispatch}
            handleSearchWithQueryParam={updateQueryParamsAndCallAPI}
            onClearButtonClicked={onClearButtonClicked}
            activeTabName={activeTab}
          />
        </div>
        <div className="col-12 col-lg-3 text-end">
          {isExportingInProgress ? (
            <div className="col">
              <p className="text-dark h5">
                <span className="spinner-border spinner-border-sm"
                  style={{ width: 20, height: 20 }} aria-hidden="true"></span>{' '}
                <i>Fetching Co-Pay Claim Report</i>
              </p>
            </div>
          ) : (
            <button type="button" className="btn btn-primary" onClick={downloadExcel}>
              Co-Pay Claim Report
            </button>
          )}
        </div>
      </div>
      <div className="card mb-3 d-flex flex-fill" style={{ minHeight: '200px' }}>
        <div className="card-body p-0 d-flex flex-column">
          <div className="table-responsive-sm table-responsive-md table-responsive-lg flex-fill">
            <table className="table table-striped table-sm m-0">
              <CopayAllClaimsHeader queryParam={queryParam} changeIdOrder={changeIdOrder} />
              <tbody>
                {sortedData && sortedData.length > 0 ?
                  sortedData.map((data: AllClaimsTypeProps, index: number) => (
                    <AllClaimsTableRow refreshListing={refreshListing} treatable={data} key={index} />
                  ))
                  : <NoDataFound />
                }
              </tbody>
            </table>
          </div>
          {maxRecordData && maxRecordData > 1 ?
            <PaginationNav currentPage={currentPage} pageCount={maxRecordData} onPageChange={handlePageChange} /> : null
          }
        </div>
      </div>
    </>
  );
};

export default memo(AllClaims);
